import bootstrapCss from 'bootstrap/dist/css/bootstrap.min.css?inline';

/** Class that opts a subtree into Bootstrap styling. */
export const BOOTSTRAP_SCOPE_CLASS = 'bootstrap-scope';

/**
 * reactstrap portals the builder's popovers, tooltips and modals into their own
 * `body > div` containers, outside BOOTSTRAP_SCOPE_CLASS. Scoped selectors never match
 * the scope root itself, so the root is the portal container, not the overlay.
 */
const PORTAL_SCOPE_ROOT = 'body > div:not(#root):has(.popover, .tooltip, .modal, .modal-backdrop)';

/**
 * Bootstrap 5 confined to BOOTSTRAP_SCOPE_CLASS subtrees and the builder's overlays, so
 * its reboot and component classes never reach the rest of the admin. It lives in the
 * `bootstrap` cascade layer declared in index.css, under Tailwind's utilities. Bootstrap
 * declares its custom properties and base typography on `:root`/`body`; inside `@scope`
 * those rules move to the scope root, where scoped rules can see them.
 */
export const scopedBootstrapCss = `@layer bootstrap {
@scope (.${BOOTSTRAP_SCOPE_CLASS}, ${PORTAL_SCOPE_ROOT}) {
${bootstrapCss
  .replace(/@charset "UTF-8";/, '')
  .replace(/:root/g, ':scope')
  .replace(/(^|[},])body(?=[{,])/g, '$1:scope')}
}
}`;
